import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/material/Box"; // Importa el componente Box
import yourImage from "../assets/Hidalgo.jpg";

import data from "./jsonBD/Hidalgo.json"; // Importa los datos del JSON
import letras from "../assets/letras/14.png"; // Cambia a la ruta de tu imagen

function Hidalgo() {
  return (
    <>
      {/* Imagen antes del Box */}
      <img
        src={yourImage}
        alt="Descripción de la imagen"
        style={{
          width: "100%", // Ajusta el ancho como desees
          height: "400px", // Mantiene la proporción
        }}
      />

      {/* Tarjeta en blanco centrada antes de las cards */}
      <Box sx={{ display: "flex", justifyContent: "center", paddingTop: 2 }}>
        <Card sx={{ maxWidth: 900, width: "100%", marginBottom: 2 }}>
          {/* Aumentar el ancho aquí */}
          <CardActionArea>
            <CardMedia
              component="img"
              height="300"
              image={letras}
              alt="Descripción de Hidalgo"
              sx={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
            <CardContent>
              <Typography variant="body2" color="text.secondary">
                Hidalgo es un estado del centro de México que se extiende al
                norte de Ciudad de México. La ventosa capital del estado,
                Pachuca tiene una torre del reloj, edificios coloniales, como la
                Iglesia barroca de San Francisco, y el Museo de Minería, que
                explora la historia minera de la región. Al oeste está Tula, un
                sitio arqueológico con pirámides y grandes columnas de piedra
                con forma de guerreros que datan del Imperio Tolteca.
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Box>

      {/* Contenedor de tarjetas con margen superior para desplazar hacia abajo */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          flexWrap: "wrap",
          paddingTop: 4,
          marginTop: 4, // Agrega margen superior para desplazar las cards hacia abajo
        }}
      >
        {data.map((item) => (
          <Card
            key={item.id}
            sx={{ maxWidth: 345, width: "100%", marginBottom: 2 }}
          >
            <CardActionArea>
              <CardMedia
                component="img"
                height="200"
                image={item.image}
                alt={item.title}
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>

      {/* Reproductor de Spotify al final, con tamaño reducido y posicionado en la esquina inferior izquierda */}
      <iframe
        id="spotify-audio"
        src="https://open.spotify.com/embed/track/4YIQtd83mCsiOjhq03jdvu"
        width="300" // Cambia el tamaño del iframe
        height="80" // Cambia el tamaño del iframe
        frameBorder="0"
        allow="encrypted-media; autoplay"
        title="Reproductor de Spotify"
        style={{
          position: "fixed",
          bottom: 20, // Espacio desde la parte inferior
          left: 20, // Espacio desde la parte izquierda
          border: "none", // Elimina el borde
          zIndex: 1000, // Asegura que esté en la parte superior
        }}
      ></iframe>
    </>
  );
}

export default Hidalgo;
